import { ChangeDetectionStrategy, Component, Inject, Injector, OnInit, ViewEncapsulation } from '@angular/core';
import { DataFieldEditBase } from '../data-field-edit-base';
import { ModuleAccessLevel } from '@fi-shared/access-right-filters/module-access-level';
import { AccessRightFilterCollectionModel, ILightWeightArea, ILightWeightObject } from '@fi-shared/models';
import { fiDoesLightWeightObjectHaveChildren } from '@fi-shared/utils/fi-does-light-weight-object-have-children';
import { FiAccessRightHelperService } from '@fi-shared/fi-shared-services/fi-access-right-helper.service';
import { IBusinessUnitModel } from '@fi-app/business-unit/business-unit.model';
import { FiDropdownItemDisabledFn } from '@fi-shared/fi-select-search/fi-select-search';

@Component({
    selector: 'data-field-edit-areas',
    templateUrl: './areas.component.html',
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.OnPush,
    host: { class: 'data-field-edit-areas' },
    standalone: false,
})
export class DataFieldEditAreasComponent extends DataFieldEditBase implements OnInit {
    get businessUnit() {
        return this.dataFieldObject as IBusinessUnitModel;
    }
    areas: ILightWeightObject[];
    private availableAreaIds: number[];
    private accessRightFilterCollection: AccessRightFilterCollectionModel;

    constructor(
        @Inject('areasAvailableForBusinessUnit') areasAvailableForBusinessUnit: ILightWeightObject[],
        @Inject('accessRightFilterCollection') accessRightFilterCollection: AccessRightFilterCollectionModel,
        private fiAccessRightHelperService: FiAccessRightHelperService,
        injector: Injector,
    ) {
        super(injector);
        this.areas = this.fiAccessRightHelperService.mergeLightWeightObjects(areasAvailableForBusinessUnit, [
            this.businessUnit.Area,
        ]);

        this.accessRightFilterCollection = accessRightFilterCollection;
        this.availableAreaIds = this.accessRightFilterCollection.AccessRightCoreFilter.AreaIds;
    }

    ngOnInit() {}

    isEnabled(): boolean {
        return this.accessRightFilterCollection.AccessLevel >= ModuleAccessLevel.Local;
    }

    getOptionDisabledFn(): FiDropdownItemDisabledFn<ILightWeightObject> {
        return (item, allItems) => {
            if (!this.availableAreaIds.includes(item.Id)) return true;
            return fiDoesLightWeightObjectHaveChildren(item, allItems);
        };
    }

    getSelectedArea(): ILightWeightObject {
        return this.areas.find((area) => area.Id === this.dataFieldObject.AreaId);
    }
}
